import _Set from "@babel/runtime-corejs3/core-js-stable/set";
var warnedSet = new _Set();
export function warnTransformsDeprecated(apiName) {
  if (!warnedSet.has(apiName)) {
    warnedSet.add(apiName);
    console.warn("[kd-table] transform \u7528\u6CD5\u5DF2\u7ECF\u8FC7\u65F6\uFF0C\u8BF7\u4F7F\u7528 pipeline \u6765\u5BF9\u8868\u683C\u8FDB\u884C\u62D3\u5C55" + "\n  \u8BF7\u79FB\u9664\u4EE5\u4E0B API \u7684\u8C03\u7528\uFF1A".concat(apiName));
  }
}